// Slow editorial infinite marquee
export default function Marquee({ items = [], bg = "bg-chai-yellow", text = "text-chai-ink", testId = "marquee" }) {
  const content = [...items, ...items];
  return (
    <div className={`w-full overflow-hidden ${bg} border-y-2 border-chai-ink py-5`} data-testid={testId}>
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {content.map((item, i) => (
          <span
            key={i}
            className={`font-serif italic text-4xl md:text-6xl ${text} mx-8 flex items-center gap-8`}
          >
            {item}
            <span className="text-chai-red not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
